var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.43,
    height: 22.93,
    viewBox: "0 0 13.43 22.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V21.79H13.43V0H0ZM12.38,20.73H1.05V1.05H12.38V20.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.89,8.98c-.29,0-.53,.24-.53,.53v2.48c0,.29,.24,.53,.53,.53s.53-.24,.53-.53v-2.48c0-.29-.24-.53-.53-.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,2.91c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.89,4.02c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.34,4.02c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,5.85c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.89,
    cy: 6.42,
    r: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.34,
    cy: 6.42,
    r: 0.55
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,8.8c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.89,9.92c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.34,9.92c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,11.74c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.89,12.86c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.34,12.86c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,14.69c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.89,15.81c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.34,15.81c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.45,17.64c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.57-.25,.57-.57-.25-.57-.57-.57Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.89,18.75c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.34,18.75c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.97,22.38c0-.3-.25-.55-.55-.55s-.55,.25-.55,.55,.25,.55,.55,.55,.55-.25,.55-.55Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.56,22.38c0-.3-.25-.55-.55-.55s-.55,.25-.55,.55,.25,.55,.55,.55,.55-.25,.55-.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerMedium);
export default __webpack_public_path__ + "static/media/LockerMedium.39982b230ce02f1a063b85b027d1a175.svg";
export { ForwardRef as ReactComponent };